import { Injectable } from "@angular/core";
import { ComunicacionRepository } from "../app.domain.repository/comunicacion.repository";
import { Comunicacion } from "../app.domain.models/comunicacion";
import { GenericEntityService } from "../core.utilidades/generic-entity.service";

@Injectable({
    providedIn: 'root',
})
export class ComunicacionApiService extends ComunicacionRepository implements GenericEntityService<Comunicacion> { }